
import { createSelector } from 'reselect'
import getHasSampledProductDataSelector from 'modules/product/redux/selectors/get-has-sampled-product-data'

export const getIdFromRatedSampleOrProductVariantSelector = ({ selectedProductVariant }) => createSelector(
  getHasSampledProductDataSelector(selectedProductVariant?.product_id),
  (sampledData) => {
    const variantId = sampledData?.variantId
    return variantId ?? selectedProductVariant?.variant_id
  }
)

export default getIdFromRatedSampleOrProductVariantSelector
